<template>
  <th :class="myClass">

    {{ column.column.name }}

    <template v-if="filters">
      <div v-if="column.values.length > 0" class="dropdown is-pulled-right no-print" :class="{ 'is-active': isActive }">
        <div class="dropdown-trigger">
          <button class="button" aria-haspopup="true" aria-controls="dropdown-menu2" @click="toggle" @keyup.esc="close">
            <span class="icon is-small">
              <i
                class="fas fa-filter"
                :class="hasFilter ? 'has-text-info' : 'has-text-grey-light'"
                aria-hidden="true"></i>
            </span>
          </button>
        </div>

        <div class="dropdown-menu" id="dropdown-menu2" role="menu">
          <div class="dropdown-content">
            <div class="dropdown-item">
              <p>
                <template v-if="!hasFilter">Selecteer 1 of meerdere items om te filteren</template>
                <template v-else><a @click="reset">Filters wissen</a></template>

                <span class="icon is-pulled-right" @click="toggleLegend()"><i class="fas fa-info"></i></span>
              </p>

              <div
                class="box"
                :class="{ 'is-hidden': !showLegend }">
                <p>Legenda</p>
                <hr>

                <div class="tags">
                  <span class="tag is-light">Item niet in filter</span>
                  <span class="tag is-info">Item in filter</span>
                  <span class="tag is-danger">Item niet gebruikt in de tabel</span>
                </div>
              </div>

              <hr class="dropdown-divider">

              <button
                type="button"
                class="button is-fullwidth is-small"
                :class="showEmpty ? 'is-info' : 'is-light'"
                @click="toggleShowEmpty">
                Toon lege items
              </button>

              <hr class="dropdown-divider">

              <div class="field">
                <div class="control">
                  <input type="text" class="input is-small" v-model="query" placeholder="Zoeken">
                </div>
              </div>

              <ul :style="`max-height: ${filterListHeight}px;`">
                <li v-show="myFilterOptions.length === 0">Geen opties gevonden met "{{ query }}"</li>
                <li
                  v-for="option in myFilterOptions"
                  :key="option.id">
                  <span
                    class="tag"
                    :class="getClass(option.id)"
                    @click="toggleFilter(option.id)">

                    {{ option.value }}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </template>
  </th>
</template>

<script>
import { mapGetters } from 'vuex'
import { strMixin } from '@/mixins/str'

export default {
  props: {
    myClass: {
      type: String,
      required: true
    },
    column: {
      type: Object,
      default: null
    },
    width: {
      type: Number,
      default: null
    },
    index: {
      type: Number,
      required: true
    },
    filterListHeight: {
      type: Number,
      required: true
    }
  },
  mixins: [
    strMixin
  ],
  data () {
    return {
      query: '',
      isActive: false,
      showLegend: false
    }
  },
  computed: {
    ...mapGetters({
      report: 'reports/report',
      filters: 'filters/filters',
      changing: 'filters/changing',
      datasets: 'datasets/datasets'
    }),
    filterEntry () {
      const filter = this.filters.find(x => x.columnId === this.column.column.id)

      return (filter) ? filter : {}
    },
    myFilter () {
      return (this.filterEntry.filter) ? this.filterEntry.filter : []
    },
    showEmpty () {
      return this.filterEntry.showEmpty === true
    },
    hasFilter () {
      return this.myFilter.length > 0 || this.showEmpty
    },
    myFilterOptions () { // TODO: This needs some rework, replace the pushing and prevent the loop through all values when no query is present.
      const values = this.column.values.filter((x) => {
        if (x.value) return x.value.toLowerCase().includes(this.query.toLowerCase())
      })

      if (values.length === 0) return []

      const options = []

      values.forEach((value) => {
        if (options.findIndex(option => option.id === value.id) === -1) {
          options.push({
            id: value.id,
            value: value.value
          })
        }
      })

      return options
    },
    used () {
      return this.datasets.map(dataset => {
        return dataset.columns[this.index].value.id
      })
    },
    style () {
      return `width: ${this.width}%;`
    }
  },
  methods: {
    sort (columnId) {
      this.$store.dispatch('reports/sort', columnId)
    },
    sortIcon (columnId) {
      if (this.order.reverse && this.order.columnId === columnId) return 'fa-chevron-down'
      return 'fa-chevron-up'
    },
    toggle () {
      this.isActive = !this.isActive
    },
    toggleLegend () {
      this.showLegend = !this.showLegend
    },
    close () {
      this.isActive = false
    },
    reset () {
      this.$store.commit('filters/RESET_FILTER', this.column.column.id)
    },
    toggleShowEmpty () {
      this.$store.commit('filters/TOGGLE_EMPTY', this.column.column.id)
    },
    toggleFilter (valueId) {
      this.$store.commit('filters/SET_FILTER', {
        valueId: valueId,
        columnId: this.column.column.id
      })
    },
    getClass (valueId) {
      if (!this.used.includes(valueId)) return 'is-danger'
      return (this.myFilter.includes(valueId)) ? 'is-info' : 'is-light'
    }
  }
}
</script>

<style scoped>
  .dropdown .button {
    border: 0;
  }

  .dropdown-menu {
    left: -6rem;
  }

  .is-danger {
    opacity: 0.4;
  }
  .box {
    margin-top: 1rem;
  }

  ul {
    overflow: auto;
  }

  ul li {
    margin: 0.25rem 0;
  }

  span {
    cursor: pointer;
  }
</style>
